/**
 * A stentor admin has read and write permissions for everything in Stentor.
 */
export const STENTOR_ADMIN: StentorAdmin = "stentor_admin";
export type StentorAdmin = "stentor_admin";
